export enum KeyCode {
	// kkey codes for Keyboard navigation for accessibility.
	TAB = 9,
	RETURN = 13,
	SPACE = 32,
	END = 35,
	HOME = 36,
	LEFT = 37,
	UP = 38,
	RIGHT = 39,
	DOWN = 40,
	ESC = 27
}
